import axiosInstance from '@/axios'

const createSubscription = (subscriptionData) => {

    return axiosInstance.post(`/api/profile/subscriptions`, subscriptionData)
}

const deleteSubscription = (subscriptionId) => {

    return axiosInstance.delete(`/api/profile/subscriptions/${subscriptionId}`)
}

const editSubscription = (subscriptionId, subscriptionData) => {

    return axiosInstance.patch(`/api/profile/subscriptions/${subscriptionId}`, subscriptionData)
}

const getProfileSubscriptions = (profileId) => {

    return axiosInstance.get(`/api/profile/subscriptions/search/findAllByProfileId?profileId=${profileId}`)
}

const validateSubscription = (validateSubscriptionDto) => {

    return axiosInstance.post(`/api/profile/subscriptions/validate`, validateSubscriptionDto)
}

const exportSubscriptionsToExcel = (params = {}) => {

    const queryParams = new URLSearchParams(params).toString()
    return axiosInstance.get(`/api/profile/api/reports/subscriptions/excel${queryParams ? '?' + queryParams : ''}`, {
        responseType: 'blob',
    })
}

const exportSubscriptionsToPdf = (params = {}) => {

    const queryParams = new URLSearchParams(params).toString()
    return axiosInstance.get(`/api/profile/pdf/getCompletedWorkReportsByPeriod${queryParams ? '?' + queryParams : ''}`, {
        responseType: 'blob',
    })
}

export {
    createSubscription,
    deleteSubscription,
    editSubscription,
    getProfileSubscriptions,
    validateSubscription,
    exportSubscriptionsToExcel,
    exportSubscriptionsToPdf,
}
